import React, {useState, Fragment} from 'react';
import { nuevoOActualizarRegistroPersonalizado, obtenerRegistrosPorURL, setearDatosAlStore } from 'store/actions/customAction';
import TooltipPersonalizado from 'components/tooltip/TooltipPersonalizado';
import DatosDeEmpresa from 'components/nuevoTarifario/DatosDeEmpresa';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import {useDispatch} from 'react-redux';
import NuevaRadio from './NuevaRadio';
import { alertaPersonalizadaSwal } from 'servicios/AlertasPersonalizados';
import { nombreDeAcciones } from 'constantes';
import DetalleDelTarifario from 'components/nuevoTarifario/detalleDelTarifario';
import ModalDeConfirmacion from 'components/Modales/ModalDeConfirmacion';
import { Typography } from '@mui/material';

const Radio = () => {
    const dispatch = useDispatch();
    const [tarifarioDeMediosRadiales] = useState('tarifarioDeMediosRadiales');
    const [datosDeRespuesta, setDatosDeRespuesta] = useState({ tipoDeAlerta: 'error', mensajeDeAlerta: '', mostrarRespuesta: false, });
    const[cargandoSolicitud, setCargandoSolicitud] = useState(false);
    const [abrirNuevaRadio, setAbrirNuevaRadio] = useState(false);
    const [steps] = useState( [{id: 0, label: 'Datos de la radio'}, {id: 1, label: "Tarifario y Disponibilidad"}, {id: 2, label: "Cobertura"}, {id: 3, label: "Datos Demográficos"}]);
    const [datosDeEmpresa, setDatosDeEmpresa] = useState({}),
    [recargarLaTabla, setRecargarLaTabla] = useState(false),
    [datosGeneralesDelTarifario, setDatosGeneralesDelTarifario] = useState({}),
    [abrirDetalleTarifario, setAbrirDetalleTarifario] = useState(false),
    [alertaDeConfirmacion, setAlertaDeConfirmacion] = useState(false);

    const [header] = useState([
        { title: 'Nombre de la radio', field: 'medioDeComunicacion.nombre'},
        { title: 'Estación', field: 'estacion'},
        { title: 'Frecuencia', field: 'siglas', render: rowData => <Typography>{rowData.frecuencia ? "FM" : "AM"}</Typography>
        },
        { title: 'Acciones', field: 'accion',
        render: rowData=><div style={{minWidth: '100px'}}>
            {
                (<div>
                    <TooltipPersonalizado title="Visualizar detalle de la radio" handleFunction={() => mostrarDetalleTarifario(rowData)} icon="visibility" fontSize={30} />
                    <TooltipPersonalizado title="Eliminar radio" handleFunction={() => mostrarAlertaDeConfirmacion(rowData)} icon="delete" fontSize={30} color="red" />

                </div>)
            }
            </div>
        },
    ]);

    const mostrarAlertaDeConfirmacion = async (elemento) => {
        setDatosGeneralesDelTarifario(elemento)
        setAlertaDeConfirmacion(true)
    }

    const mostrarDetalleTarifario = async (elemento) => {
        setCargandoSolicitud(true);

        let respuesta = await dispatch(obtenerRegistrosPorURL({ controller: tarifarioDeMediosRadiales, saveInStore: false, nombreDelMetodo: "listar/registros", parametro: elemento.medioDeComunicacion?.id}));

        setCargandoSolicitud(false);

        if(respuesta?.error) return alertaPersonalizadaSwal(`${respuesta.error?.message || "No se pudo obtener la información de la radio"}`);

        if(respuesta?.data?.length === 0) return alertaPersonalizadaSwal("No existen datos para mostrar");

        setDatosGeneralesDelTarifario(respuesta.data)
        setAbrirDetalleTarifario(true)
    }

    const handClose = (_, reason) => {
        if (reason === 'clickaway') {return}
        changeDataResponse('error', '', false)
    };

    const changeDataResponse = (tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta = false) => setDatosDeRespuesta({tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta,})

    const addRegister= () => {
        if(!datosDeEmpresa?.ejecutivoDeMedios?.cui) return alertaPersonalizadaSwal("Debe completar los datos Contacto de medios para agregar otra radio", "", "warning")
        setAbrirNuevaRadio(true);
    }

    const cerrarNuevaRadio= (recargar = false) => {
        dispatch(setearDatosAlStore({ dispatchAction : nombreDeAcciones.LIMPIAR_TODO_EL_REDUCER}));
        setAbrirNuevaRadio(false)
        setRecargarLaTabla(recargar)
    };

    const cerrarDetalleDelTarifario = () => setAbrirDetalleTarifario(false)

    const accionDeAlertaDeConfirmacion = async () => {
        setAlertaDeConfirmacion(false);
        setCargandoSolicitud(true);
        changeDataResponse('error', "")

        const data = { controller: tarifarioDeMediosRadiales, action: 'deshabilitar', data: {}, nombreDelMetodo: `deshabilitar/${datosGeneralesDelTarifario?.medioDeComunicacion?.id}` };
        const respuesta = await dispatch(nuevoOActualizarRegistroPersonalizado(data));
        setCargandoSolicitud(false);
        if(respuesta?.error) return alertaPersonalizadaSwal(respuesta.error?.message || "", "", '');
        alertaPersonalizadaSwal(respuesta?.data || "Registro eliminado correctamente", "", 'success');
        setRecargarLaTabla(true)
    }

    const cerrarAlertaDeConfirmacion = () => setAlertaDeConfirmacion(false);

    const { tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta} = datosDeRespuesta;

    return (
        <Fragment>
            {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
            <AlertaDeRespuesta type={tipoDeAlerta} content={mensajeDeAlerta} open={mostrarRespuesta} handClose={handClose}/>

            <DatosDeEmpresa
                header={header}
                tituloGeneral={"FORMULARIO DE REGISTRO RADIO"}
                icon={"radio"}
                tituloDeTabla={"LISTADO DE RADIOS REGISTRADAS"}
                addRegister={addRegister}
                nombreToolTip={"AGREGAR OTRA RADIO"}
                iconTabla={"radio"}
                setDatosDeEmpresa={setDatosDeEmpresa}
                controladorTarifario={"tarifarioDeMediosRadiales"}
                recargarLaTabla={recargarLaTabla}
                datosDeEmpresa={datosDeEmpresa}
                setRecargarLaTabla={setRecargarLaTabla}
                tipoMedio="radio"
            />

            {abrirNuevaRadio && (
                <NuevaRadio
                    openFullScreenDialog={abrirNuevaRadio}
                    handleClose={cerrarNuevaRadio}
                    title={"Formulario para agregar nueva radio"}
                    steps={steps}
                    datosDeEmpresa={datosDeEmpresa}
                />
            )}
            {abrirDetalleTarifario && (
                <DetalleDelTarifario
                    openFullScreenDialog={abrirDetalleTarifario}
                    handleClose={cerrarDetalleDelTarifario}
                    title={'Detalle del radio registrado'}
                    datosGeneralesDelTarifario={datosGeneralesDelTarifario}
                    tipoDelMedio={"radio"}
                    mostrarDetalleDelCanal={mostrarDetalleTarifario}
                />
            )}
            {alertaDeConfirmacion && (
                <ModalDeConfirmacion
                    title={`¿Está seguro de eliminar la radio ${datosGeneralesDelTarifario?.medioDeComunicacion?.nombre || ""}?`} message={"No podrá revertir esta acción"}
                    open={alertaDeConfirmacion} closeModal={cerrarAlertaDeConfirmacion} titleButton={"Sí, estoy seguro"}
                    actionAdd={accionDeAlertaDeConfirmacion}
                />
            )}
        </Fragment>
    );
}

export default Radio;